var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMarkSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.00012207H2C0.9 0.00012207 0 0.900122 0 2.00012V16.0001C0 17.1001 0.9 18.0001 2 18.0001H16C17.1 18.0001 18 17.1001 18 16.0001V2.00012C18 0.900122 17.1 0.00012207 16 0.00012207ZM9.01 15.0001C8.31 15.0001 7.75 14.4401 7.75 13.7401C7.75 13.0301 8.31 12.4901 9.01 12.4901C9.72 12.4901 10.26 13.0301 10.26 13.7401C10.25 14.4301 9.72 15.0001 9.01 15.0001ZM12.02 7.60012C11.26 8.71012 10.54 9.06012 10.15 9.77012C9.99 10.0601 9.93 10.2501 9.93 11.1801H8.11C8.11 10.6901 8.03 9.89012 8.42 9.20012C8.91 8.33012 9.84 7.81012 10.38 7.04012C10.95 6.23012 10.63 4.71012 9.01 4.71012C7.95 4.71012 7.43 5.51012 7.21 6.19012L5.56 5.49012C6.01 4.15012 7.22 3.00012 8.99 3.00012C10.47 3.00012 11.48 3.67012 12 4.52012C12.44 5.24012 12.7 6.59012 12.02 7.60012Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkSquare);
export default __webpack_public_path__ + "static/media/question-mark-square.38f29dd89b99741c1dc1774f26279d6e.svg";
export { ForwardRef as ReactComponent };